export const COLORS = {
  white: '#fff',
  black: '#000',
  text: '#4E4E4E',
  textInput: '#222222',
  main: '#0088F5',
  bgButton: '#203461',
  lightRed: '#FEF0F4',
  lightRed2: '#FEF2F5',
  lightRed50: '#F25275',
  red: '#E30736',
  lightGreen: '#EEFBF4',
  green: '#4DBC6C',
  borderNeutral: '#E9E9E9',
  //gray
  gray: '#F4F4F4',
  grayText: '#7A7A7A',
  grayBorder: '#D0D5DD',
  grayBorder2: '#D3D3D3',
  //origin
  origin: '#FFF2EE',
  originText: '#F57322',
  //blue
  blue_100: '#F0F8FF',
  orange: '#F57322',
  blue: '#0088F5'
}

